import { makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import { FC } from "react"
import { colors } from "../../utils/theme"
import { PrimaryButton } from "../atoms/button/Button"
import Logo from "../atoms/Logo"
import { TitledCard } from "../molecules/titledCard/TitledCard"
import { BaseTemplate } from "../templates/BaseTemplate"
import isMobile from "is-mobile"

const useStyles = makeStyles((theme) => ({
  logo: {
    position: "absolute",
    top: theme.spacing(6),
    left: theme.spacing(6),
  },
  button: {
    width: "100%",
  },
  marginBottom32: {
    marginBottom: theme.spacing(4),
  },
  denim: {
    color: colors.neutral.denim,
  },
}))

const ResetPasswordSuccessMobile: FC = () => {
  const classes = useStyles()
  const mobile = isMobile()

  return (
    <BaseTemplate>
      <Logo className={classes.logo} />
      <TitledCard title="Success!">
        <Typography
          variant="body1"
          className={clsx(classes.marginBottom32, classes.denim)}
        >
          Your password has been reset.
          {!mobile ? " Please use your device to log into the vira app" : ""}
        </Typography>
        {mobile && (
          <PrimaryButton
            className={classes.button}
            onClick={() => window.open("vira://reset-password/", "_blank")}
          >
            Click here to open the app
          </PrimaryButton>
        )}
      </TitledCard>
    </BaseTemplate>
  )
}

export default ResetPasswordSuccessMobile
